import { cn } from "packages/dsaui/src/utils";

export interface SpinnerProps {
  className?: string;
  size?: number;
}

export const Spinner = ({ className, size = 40 }: SpinnerProps) => (
  <div
    aria-label="Loading"
    className={cn(
      "border-t-dsa-red animate-spin rounded-full border-2 border-gray-200",
      className,
    )}
    role="status"
    style={{ height: size, width: size }}
  />
);

export default Spinner;
